import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';


export const getProductMap = createAsyncThunk('/GetProductMap', async (search) => {
    const response = await axios.get(`/GetProductMap/${search}`);
    return response.data;
  });

export const setPushProductMap = createAsyncThunk('/SetPushProductMap', async (push) => {

    const response = await axios.post(`/SetPushProductMap`, push);
    return response.data;
  });


export const getDeleteProductMap = createAsyncThunk(`/GetDeleteProductMap`, async (id) => {
    const response = await axios.get(`/GetDeleteProductMap/${id}`);
    return response.data;
  });

const productAlternativeSlice = createSlice({
  name: 'productSku',
  initialState: {
    loading: false,
    error: '',
    ProductSkuMap: [],
},
reducers: {
  resetDescriptions(state) {
    state.ProductSkuMap = [];
  }
},
extraReducers: {
  [getProductMap.pending]: (state) => {
    state.loading = true;
  },
  [getProductMap.rejected]: (state, action) => {
    state.error = action.payload;
    state.loading = false;
  },
  [getProductMap.fulfilled]: (state, action) => {
    state.ProductSkuMap = action.payload;
    state.loading = false;
  },
  [setPushProductMap.pending]: (state) => {
    state.loading = true;
  },
  [setPushProductMap.rejected]: (state, action) => {
    state.error = action.payload;
    state.loading = false;
  },
  [setPushProductMap.fulfilled]: (state, action) => {
    state.ProductSkuMap = action.payload;
    state.loading = false;
  },
  [getDeleteProductMap.pending]: (state) => {
    state.loading = true;
  },
  [getDeleteProductMap.rejected]: (state, action) => {
    state.error = action.payload;
    state.loading = false;
  },
  [getDeleteProductMap.fulfilled]: (state, action) => {
    state.DeletePostCode = action.payload;
    state.loading = false;
  }
}
});
export const productSkuActions = productAlternativeSlice.actions;
export default productAlternativeSlice;
